import * as React from 'react';
import styled from 'styled-components';
import { isValidHex } from '../../containers_v2/map/colorScale';
import { DefaultInputBlock } from '../../styles/global/css/GlobalInput';
import { DefaultTextDiv } from '../../styles/global/css/GlobalText';
import { BorderColor, DarkGreySidely2, PrimaryColor, SidelyBlack, SurfaceColor } from '../../styles/global/css/Utils';

// The parts the map colour editors share: labels, icon buttons, a colour
// swatch and the hex field beside it.

export const Label = styled(DefaultTextDiv)`
	font-size: 12px;
	color: ${DarkGreySidely2};
`;

export const IconButton = styled.button<{ disabled?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 26px;
	height: 26px;
	padding: 0;
	border: 1px solid ${BorderColor};
	border-radius: 6px;
	background-color: ${SurfaceColor};
	color: ${SidelyBlack};
	cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
	opacity: ${p => p.disabled ? 0.4 : 1};
	&:hover {
		border-color: ${p => p.disabled ? BorderColor : PrimaryColor};
	}
`;

export const SmallInput = styled(DefaultInputBlock)`
	height: 28px;
	padding: 0 8px;
	font-size: 12px;
`;

export const HexInput = styled(SmallInput)`
	width: 84px;
	font-family: monospace;
	text-transform: uppercase;
`;

export const Swatch = styled.input`
	width: 28px;
	height: 28px;
	padding: 0;
	border: 1px solid ${BorderColor};
	border-radius: 6px;
	background: none;
	cursor: pointer;
	&::-webkit-color-swatch-wrapper {
		padding: 2px;
	}
	&::-webkit-color-swatch {
		border: none;
		border-radius: 4px;
	}
	&::-moz-color-swatch {
		border: none;
		border-radius: 4px;
	}
`;

/** A hex field that only commits a complete, valid colour. */
export function HexField(props: { color: string, onChange: (color: string) => void }) {
	const [draft, setDraft] = React.useState(props.color);
	React.useEffect(() => setDraft(props.color), [props.color]);
	const commit = () => {
		const candidate = draft.startsWith('#') ? draft : `#${draft}`;
		if (isValidHex(candidate)) props.onChange(candidate.toUpperCase());
		else setDraft(props.color);
	};
	return <HexInput
		value={draft.replace('#', '')}
		maxLength={6}
		onChange={e => setDraft(e.target.value)}
		onBlur={commit}
		onKeyDown={e => { if (e.key === 'Enter') (e.target as HTMLInputElement).blur(); }}
	/>;
}
